const appStyle = theme => ({
  contentTable: {
    height: "600px"
  },
  tableGeneral: {
    "& .MuiTableCell-root": {
      color: "#000000",
      fontFamily: '"Roboto"',
      fontSize: "13px",
      lineHeight: "18px",
      padding: "14px 5px"
    },
    "& .hideCell": {
      display: "none"
    }
  },
  cellOperativo: {
    "& .MuiTableCell-root": {
      fontWeight: "bold"
    }
  }
});

export default appStyle;
